import axios from "axios";
import { SERVER_URL } from "../../config";
import { appendListQuery, appendTimestamp } from "../../common/shared";
import sessionTimer from "../../common/sessionTimeout";
import cookie from "react-cookies";
import store from "../../redux/store";
import {
  RESET_REDUCER,
  SET_ADMIN_DEFAULT_PLAN_SETTINGS,
  SET_ADVISOR_DEFAULT_PLAN_SETTINGS,
} from "../../redux/constants";
import { getAdvisorDefaultPlanSettings } from "../advisor/defaultPlanSettings";
import { getDefaultPlanSettings } from "../admin/defaultPlanSettings";

export const BAD_PASSWORD = "badPassword";
export const FINAL_BAD_PASSWORD = "finalBadPassword";
export const LOCKED_ACCOUNT = "lockedAccount";
export const INACTIVE_ACCOUNT = "inactiveAccount";
export const CURRENT_USER_COOKIE = "CURRENT_USER_COOKIE";

export const user_current = () => {
  return axios.get(appendTimestamp(`${SERVER_URL}/user/current`));
};

export const spring_security_logout = () => {
  if (store) {
    store.dispatch({
      type: RESET_REDUCER,
    });
  }
  sessionTimer.stop();
  cookie.remove(CURRENT_USER_COOKIE);
  sessionStorage.clear();
  return axios.get(appendTimestamp(`${SERVER_URL}/j_spring_security_logout`));
};

export const spring_security_login = (username, password) => {
  return axios({
    method: "post",
    url: appendTimestamp(`${SERVER_URL}/j_spring_security_check`),
    data: `j_username=${username}&j_password=${password}`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

export const do_login = (username, password) => {
  return new Promise((resolve, reject) => {
    user_current()
      .then(
        spring_security_login(username, password).then((response) => {
          if (response.data.toString().includes(BAD_PASSWORD)) {
            reject(BAD_PASSWORD);
          } else if (response.data.toString().includes(FINAL_BAD_PASSWORD)) {
            reject(FINAL_BAD_PASSWORD);
          } else if (response.data.toString().includes(LOCKED_ACCOUNT)) {
            reject(LOCKED_ACCOUNT);
          } else if (response.data.toString().includes(INACTIVE_ACCOUNT)) {
            reject(INACTIVE_ACCOUNT);
          } else {
            sessionTimer.reset();
            cookie.save(CURRENT_USER_COOKIE, {
              userId: response.data.payload["userId"],
            });

            const userData = response.data.payload;

            if (userData.userRoles.includes("Admin")) {
              getDefaultPlanSettings(userData.userId).then((planSettings) => {
                store.dispatch({
                  type: SET_ADMIN_DEFAULT_PLAN_SETTINGS,
                  data: planSettings.defaultSettings,
                });
                resolve(userData);
              });
            }

            getAdvisorDefaultPlanSettings(userData.advisorId).then(
              (planSettings) => {
                store.dispatch({
                  type: SET_ADVISOR_DEFAULT_PLAN_SETTINGS,
                  data: planSettings.defaultSettings,
                });
                resolve(userData);
              }
            );
          }
        })
      )
      .catch((error) => {
        console.log("Error: ", error);
      });
  });
};

export const get_advisor_image = (id) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/advisors/info/getImage/${id}`;

    axios.post(targetUrl, {}).then((response) => {
      resolve(response.data.payload.userImage);
    });
  });
};

export const getAdvisorAppearance = (advisorId) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/advisor/${advisorId}/advisorappearance`;
    axios.get(targetUrl).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const forgot_pwd_validatemail = (email) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/forgotpwdvalidatemail`;

    axios
      .post(targetUrl, {
        securityQtn: null,
        sqenabled: "Y",
        answer: null,
        email: email,
        questionId: null,
      })
      .then((response) => {
        resolve(response.data.payload);
      });
  });
};

export const forgot_password_reset = (email, questionId, answer) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/forgotpasswordreset`;

    axios
      .post(targetUrl, {
        email: email,
        questionId: questionId,
        answer: answer,
      })
      .then((response) => {
        resolve(response);
      });
  });
};
